export const HelpCenterUrls = {
  SCREEN_SHARE_ERROR: 'https://help.preciate.com/understanding-screen-share-errors',
  PREPARE_NETWORK: 'https://help.preciate.com/prepare-your-network-for-preciate-events',
  ENABLE_CAMERA_AND_MIC: 'https://help.preciate.com/enable-camera-and-mic-for-preciate-social',
  SCOOT_SCREEN_SHARE_ERROR: 'https://help.scoot.app/understanding-screen-share-errors',
  SCOOT_PREPARE_NETWORK: 'https://help.scoot.app/prepare-your-network-for-events',
  SCOOT_ENABLE_CAMERA_AND_MIC: 'https://help.scoot.app/enable-camera-and-mic-for-scoot',
};
